module.exports = __webpack_public_path__ + "static/media/euro.fc1b72b1.svg";